module.exports = __webpack_public_path__ + "static/media/Wyngs assets-01.5b2d0e84.png";